import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { NwbVersion } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const nwbVersionsUrl = `${environment.apiUrl}/nwbversions`;

@Injectable()
export class NwbVersionService {
  constructor(private readonly httpService: HttpService) {}

  getNwbVersionsOrderedByDateDesc(): Observable<NwbVersion[]> {
    return this.httpService.get<NwbVersion[]>(nwbVersionsUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/nwb-version.service.ts